<script>
export default {
  data() {
    return {
      filterOpt: "",
      typeFiltering: "Setor",
      notSearch: false,
      notExists: false,
      searchValue: "",
      isFiltering: false
    }
  },
  computed: {
    isSearching() {
      return !!this.searchValue;
    }
  },
  methods: {
    inputSearch(val) {
      this.searchValue = val.trim();
      this.isFiltering = false;
    },
    clearSearch() {
      this.searchValue = ""
      this.isFiltering = false;
    },
  } 
}
</script>